import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css' // Default Vite CSS, can be kept or removed if global.css covers all needs
import './styles/global.css' // Import our new global styles
import * as Sentry from "@sentry/react"; // Added Sentry import

// Initialize Sentry
// IMPORTANT: Replace with your actual DSN and configure release/environment properly.
if (import.meta.env.PROD) { // Only initialize Sentry in production builds
  Sentry.init({
    dsn: "https://4f7df707eb7bac1c427d866070f43e6c@o4509372859285504.ingest.de.sentry.io/4509372860792912",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Additional Replay configuration, if needed:
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, // Capture 10% of transactions for performance monitoring. Adjust as needed.
    // Session Replay
    replaysSessionSampleRate: 0.05, // This sets the sample rate at 5%. Adjust as needed.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, sample the session when an error occurs.
    
    environment: import.meta.env.MODE, // e.g., 'production', 'development'
    release: "smartie-frontend@" + __APP_VERSION__, // Using __APP_VERSION__ defined via Vite
    // For release, ensure your Vite config defines __APP_VERSION__ (e.g., from package.json version)
    // Example in vite.config.ts: define: { '__APP_VERSION__': JSON.stringify(process.env.npm_package_version) }
  });
}

const rootElement = document.getElementById('smartie-chat-widget-root');

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  console.error('Failed to find the root element #smartie-chat-widget-root. Smartie AI widget will not load.');
}
